<template>
  <rect
    class="left-bar"
    x="10"
    y="24"
    width="4"
    height="5"
    rx="1.5"
    fill="currentColor"
  />
  <rect
    class="middle-bar"
    x="17"
    y="18"
    width="4"
    height="11"
    rx="1.5"
    fill="currentColor"
  />
  <path
    class="arrow"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M28 15.9998H29.7642C30.6428 15.9998 31.1167 14.9693 30.545 14.3022L26.5206 9.60708C26.247 9.28787 25.7531 9.28787 25.4795 9.60708L21.4551 14.3022C20.8834 14.9693 21.3573 15.9998 22.2359 15.9998H24V27.4998C24 28.3282 24.6716 28.9998 25.5 28.9998H26.5C27.3285 28.9998 28 28.3282 28 27.4998V15.9998Z"
    fill="currentColor"
  />
</template>
